import { DocsConfig } from "./config-manager";
import { ConfigItem } from "./config-constants";
export default DocsConfig;
export { ConfigItem };
//# sourceMappingURL=index.js.map